export default __webpack_public_path__ + "static/media/schedule-icon.c3ba8f2e.svg";